import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core'

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { BootstrapTooltip } from 'components/BootstrapTooltip'
import { IReportDisabledFields } from 'store/modules/report/types'
import { isAggregatedReportSortDisabled } from 'utils/reportDisabledFields'
import { CONVERSION_EXPLANATION } from 'utils/conversion'

const headCells = [
  { id: 'name', label: 'Nome', minWidth: 275 },
  { id: 'salesDay', label: 'Vendas do dia', minWidth: 150 },
  { id: 'goalDay', label: 'Meta do dia', minWidth: 150 },
  { id: 'sold', label: 'Faturamento', minWidth: 125 },
  { id: 'goalPercent', label: '%', minWidth: 50 },
  { id: 'acDayGoal', label: 'Meta ideal', minWidth: 150 },
  { id: 'mainGoalPercent', label: '%', minWidth: 50 },
  { id: 'mainGoal', label: 'Meta do mês', minWidth: 200 },
  { id: 'projection', label: 'Projeção de venda', minWidth: 175 },
  { id: 'conversionRate', label: 'Conversão', minWidth: 140 },
  { id: 'lastYearVariation', label: 'Último ano', minWidth: 155 },
  { id: 'sales', label: 'Nº Vendas', minWidth: 125 },
  { id: 'average.tm', label: 'Ticket Médio', minWidth: 150 },
  { id: 'average.pv', label: 'Peça/Venda', minWidth: 100 },
  { id: 'average.pm', label: 'Preço Médio', minWidth: 150 },
  { id: 'total.items', label: 'Nº Peças', minWidth: 125 }
] as const

type OrderByProps = (typeof headCells)[number]['id']

interface StoresTableHeadProps {
  disabledFields?: IReportDisabledFields
  // A coluna de conversão só existe quando alguma loja da tabela tem contagem
  showConversion?: boolean
  order: 'asc' | 'desc'
  orderBy: OrderByProps
  onHoverHeader: () => void
  onRequestSort: (property: OrderByProps) => void
}

const StoresTableHead = ({
  disabledFields = {},
  showConversion = false,
  order,
  orderBy,
  onHoverHeader,
  onRequestSort
}: StoresTableHeadProps) => {
  const createSortHandler = (property: OrderByProps) => {
    if (isAggregatedReportSortDisabled(property, disabledFields)) return

    onRequestSort(property)
  }

  return (
    <TableHead>
      <TableRow onMouseEnter={onHoverHeader}>
        {headCells
          .filter(headCell => showConversion || headCell.id !== 'conversionRate')
          .map((headCell, index) => {
          const isDisabled = isAggregatedReportSortDisabled(
            headCell.id,
            disabledFields
          )

          return (
            <TableCell
            key={headCell.id}
            sortDirection={!isDisabled && orderBy === headCell.id ? order : false}
            style={{
              minWidth: headCell.minWidth,
              ...(index === 0 && { zIndex: 10 })
            }}
          >
            <TableSortLabel
              active={!isDisabled && orderBy === headCell.id}
              disabled={isDisabled}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={() => createSortHandler(headCell.id)}
            >
              {headCell.label}
              {(() => {
                let tooltipTitle = ''
                if (headCell.label === 'Meta ideal') {
                  tooltipTitle = 'Meta até último dia com vendas.'
                } else if (headCell.label === 'Meta do mês') {
                  tooltipTitle = 'Meta total mensal cadastrada para a loja.'
                } else if (headCell.label === 'Último ano') {
                  tooltipTitle = 'Comparação com as vendas do ano anterior.'
                } else if (headCell.label === 'Conversão') {
                  tooltipTitle = CONVERSION_EXPLANATION
                }

                if (tooltipTitle) {
                  return (
                    <BootstrapTooltip title={tooltipTitle}>
                      <ErrorOutlineIcon style={{ color: '#C4C4C4', fontSize: 20, marginLeft: 5 }} />
                    </BootstrapTooltip>
                  )
                }
                return null
              })()}
            </TableSortLabel>
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

export default StoresTableHead
